module.exports = __webpack_public_path__ + "static/media/eat-well.5715d48c.mp4";